var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"autoloader"},[_c('app-loader',{attrs:{"is-local":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }